import {
  CHANGE_EXHIBITORS_FILTER,
  CHANGE_MEDIA_PARTNERS_FILTER,
  CHANGE_ROUND_TABLES_FILTER,
  CHANGE_PERSONALITIES_FILTER,
  CHANGE_DATE,
  CHANGE_LOCALE,
  TOGGLE_MENU,
} from './actionTypes';


export const changeExhibitorsFilter = (newFilter) => {
  return {
    type: CHANGE_EXHIBITORS_FILTER,
    newFilter,
  };
};

export const changeMediaPartnersFilter = (newFilter) => {
  return {
    type: CHANGE_MEDIA_PARTNERS_FILTER,
    newFilter,
  };
};

export const changePersonalitiesFilter = (newFilter) => {
  return {
    type: CHANGE_PERSONALITIES_FILTER,
    newFilter,
  };
};

export const changeRoundTablesFilter = (newFilter) => {
  return {
    type: CHANGE_ROUND_TABLES_FILTER,
    newFilter,
  };
};

export const changeDate = (newDate) => {
  return {
    type: CHANGE_DATE,
    newDate,
  };
};

export const changeLocale = (newLocale) => {
  return {
    type: CHANGE_LOCALE,
    newLocale,
  };
};

export const toggleMenu = (newState) => {
  return {
    type: TOGGLE_MENU,
    newState,
  };
};



/** WEBPACK FOOTER **
 ** ./src/actions/index.js
 **/